import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Link } from 'react-router-dom';
import qs from 'qs';
import moment from 'moment';

// Global Types
import { AppState } from 'services/types';
import {
    MyTimesheetEntryDate,
    MyTimesheetEntriesProps
} from 'services/myTimesheetEntries/types';

// Global Selectors
import { makeSelectMyTimesheetEntryDate } from 'services/myTimesheetEntries/selectors';

interface OwnProps extends MyTimesheetEntriesProps {
    children: React.ReactElement;
}

interface ConnectedProps {
    date?: MyTimesheetEntryDate;
}

type Props = OwnProps & ConnectedProps;

/**
 * Links to the specific day that a timesheet entry exists on the "My Timesheets" page.
 */
export class MyTimesheetEntryDateLink extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { children, date } = this.props;
        if (!date) {
            return null;
        }
        return (
            <Link
                to={{
                    pathname: '/organization/time/my-timesheets',
                    search: qs.stringify({
                        date: moment(date, 'YYYY-MM-DD')
                            .startOf('isoWeek')
                            .format('YYYY-MM-DD'),
                        dayOfWeek: moment(date, 'YYYY-MM-DD').isoWeekday() - 1
                    })
                }}
            >
                {children}
            </Link>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    date: makeSelectMyTimesheetEntryDate()
});

export default connect(mapStateToProps)(MyTimesheetEntryDateLink);
